import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {select} from '@ngrx/store';
import {map, merge, Observable} from 'rxjs';
import {Store} from '@ngrx/store';

import {selectUnreadAlertsCount} from 'src/app/core/store/alerts/alerts.selector';
import {selectActiveUserAlertsCount} from 'src/app/core/store/active-user/active-user.selector';

@Component({
  selector: 'alert-count-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-count-display.component.html',
  styleUrl: './alert-count-display.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertCountDisplayComponent {
  unreadAlertsCount$: Observable<number> = this.store$.pipe(select(selectUnreadAlertsCount));
  activeUserAlertsCount$: Observable<number> = this.store$.pipe(select(selectActiveUserAlertsCount));

  mostRecentCount$: Observable<number>;

  constructor(private store$: Store) {
    this.mostRecentCount$ = merge(this.unreadAlertsCount$, this.activeUserAlertsCount$).pipe(map(value => value));
  }
}
